const Account = () => <h1>This is the Account Page</h1>;

export default Account;